// src/features/records/components/MapView/components/LoadingOverlay.js
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ message, showAfterDelay = 100 }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const overlayMessage = message || t('records.views.map.loading.default');

  useEffect(() => {
    // Show loading overlay after a brief delay to avoid flash for fast loads
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, showAfterDelay);

    return () => clearTimeout(timer);
  }, [showAfterDelay]);

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.spinner}>
        <span className={styles.spinnerDot}></span>
        <span className={styles.spinnerDot}></span>
        <span className={styles.spinnerDot}></span>
      </div>
      <p className={styles.message}>{overlayMessage}</p>
    </div>
  );
};

export default LoadingOverlay;
